import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";

//auth
import { Auth } from "lib/firebase";

// context
import { AppContext } from "components";

// components
import LoginContainer from "containers/Auth/Login";
import { NavigationBar } from "shared/components/NavBar";
import { Toast } from "shared/components/toast";
// controllers
import { getRoutesByRole, getDefaultPageByRole } from "controllers/Module";
import Admin from "modules/admin";
import { ImageModal } from "shared/components/modal";

class AppRouter extends React.Component {
    constructor(props) {
        super(props);

        this.role = null;
        this.state = {
            url: '',
            loading: true,
            isLoggedIn: false
        };
    }

    async componentDidMount() {
        await this.context.showLoading();

        Auth.onAuthStateChanged(async auth => {
            let isLoggedIn = false;

            this.role = localStorage.getItem('role');
            if (auth && auth.uid && this.role) {
                isLoggedIn = true;
                window.uid = auth.uid;
                window.role = this.role;
            }

            this.setState({ loading: false, isLoggedIn });
            await this.context.hideLoading();
        });

        Auth.onIdTokenChanged(async user => {
            this.role = window.localStorage.getItem('role');
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.url !== window.location.pathname) {
            this.setState({ url: window.location.pathname });
        }
        window.onpopstate = e => {
            this.setState({ url: window.location.pathname });
        };
    }

    shouldComponentUpdate;

    defineRoutes() {
        const modules = getRoutesByRole(this.role);
        const redirectURL = getDefaultPageByRole(this.role);

        return (
            <React.Fragment>
                <Router>
                    <Switch>
                        {modules.map((module) => (
                            <Route key={module.url}
                                path={module.url}
                                exact={true}
                                component={module.component}
                            />
                        ))}
                        <Route path="/admin" exact={true} component={Admin} />
                        <Redirect to={redirectURL} />
                    </Switch>

                    <Toast />
                    <NavigationBar />
                    <ImageModal />
                </Router>
            </React.Fragment>
        );
    }

    render() {
        const { isLoggedIn, loading } = this.state;

        if (isLoggedIn) {
            document.body.classList.add('has-navbar-fixed-top');
        }

        return (
            <div>
                <div className="">
                    <div className="">
                        {isLoggedIn ? (
                            <div>
                                {!loading && (this.defineRoutes())}
                            </div>
                        ) : !loading ? (
                            <Router>
                                <Switch>
                                    <Route path="/sign-in" component={LoginContainer} />
                                    <Redirect to="/sign-in" />
                                </Switch>
                            </Router>
                        ) : (<div></div>)}
                    </div>
                </div>
            </div>
        );
    }
}

AppRouter.contextType = AppContext;
export default AppRouter;
